<ion-row class="bank-detail-row">
  <ion-col size="12" data-cy="bank-detail-row-customer-information">
    <div>
      <p data-cy="bank-detail-row-customer-name">
        <strong class="customer-name">{{
          bankDetail.customerName | titlecase
        }}</strong>
        <span data-cy="bank-detail-row-customer-number">
          ({{ bankDetail.customerNumber }})
        </span>
      </p>
    </div>
  </ion-col>

  <ion-col size="5.5">
    <ion-row class="bank-name-row">
      <span class="bank-type" *ngIf="bankDetail.isPrimary">
        <strong data-cy="bank-detail-row-type">{{
          'i18n.payments.paymentPreferences.primary' | translate
        }}</strong>
        &nbsp;|&nbsp;
      </span>
      <span class="bank-name" data-cy="bank-detail-row-bank-name">
        {{ bankDetail.bankName }}
      </span>
    </ion-row>

    <ion-row size="12" data-cy="bank-detail-row-account-number" data-private>
      {{ 'i18n.payments.paymentPreferences.accountNumber' | translate }}
      : *****{{ bankDetail.last4AccountNumber }}
    </ion-row>

    <ion-row size="12" data-cy="bank-detail-row-routing-number" data-private>
      {{ 'i18n.payments.paymentPreferences.routingNumber' | translate }}:
      *****{{ bankDetail.routingNumber | slice: -4 }}
    </ion-row>
    <ng-container *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="nickNameField"></ng-container>
    </ng-container>
  </ion-col>
  <ion-col size="5.5">
    <ng-container *ngIf="!isMobile">
      <ng-container *ngTemplateOutlet="nickNameField"></ng-container>
    </ng-container>
    <ion-row *ngIf="isAutopay" size="12" data-cy="bank-detail-row-start-date">
      {{ 'i18n.payments.paymentPreferences.startDate' | translate }}:
      {{ bankDetail.autoDeductStartDateFormatted }}
    </ion-row>
  </ion-col>
  <ion-col size="1">
    <div class="buttons-column">
      <ion-icon
        color="success"
        name="ellipsis-vertical"
        data-cy="bank-detail-row-options"
        (click)="openMoreOptions()"
      >
      </ion-icon>
    </div>
  </ion-col>
</ion-row>

<ng-template #nickNameField>
  <ion-row data-cy="bank-detail-row-nick-name">
    {{ 'i18n.payments.paymentPreferences.nickname' | translate }} :
    {{ bankDetail.nickName ? bankDetail.nickName : '-' }}
  </ion-row>
</ng-template>
